<template>
  <div v-loading="loading">
    <div class="banner">
      <div style="width: 1200px; margin: 0 auto; position: relative">
        <p class="top-title" :title="matterName">{{ matterName }}</p>
        <el-button round class="Map_guidance" @click="toMap(matterObj)"
          >地图指引</el-button
        >
      </div>
    </div>
    <div style="margin-top: 10px">
      <div class="cont">
        <div class="cont-left" :class="{ fixedNavbar: isfixTab }">
          <ul>
            <!-- <li :class="{ 'active': navgatorIndex == 1 }"> <a href="#t1" @click="handleLeft(1)">基本信息</a> </li>
            <li :class="{ 'active': navgatorIndex == 2 }"> <a href="#t2" @click="handleLeft(2)">申请材料</a> </li>
            <li :class="{ 'active': navgatorIndex == 3 }"> <a href="#t3" @click="handleLeft(3)">法定依据</a> </li>
            <li :class="{ 'active': navgatorIndex == 4 }"> <a href="#t4" @click="handleLeft(4)">申请条件</a> </li>
            <li :class="{ 'active': navgatorIndex == 5 }"> <a href="#t5" @click="handleLeft(5)">收费标准</a> </li> -->

            <li :class="{ active: navgatorIndex == 1 }">
              <a @click="handleLeft('t1', 1)">基本信息</a>
            </li>
            <li :class="{ active: navgatorIndex == 2 }">
              <a @click="handleLeft('t2', 2)">申请材料</a>
            </li>
            <li :class="{ active: navgatorIndex == 3 }">
              <a @click="handleLeft('t3', 3)">法定依据</a>
            </li>
            <li :class="{ active: navgatorIndex == 4 }">
              <a @click="handleLeft('t4', 4)">申请条件</a>
            </li>
            <li :class="{ active: navgatorIndex == 5 }">
              <a @click="handleLeft('t5', 5)">收费标准</a>
            </li>
          </ul>
        </div>
        <div id="cont-right">
          <div class="jbxx" id="t1">
            <p class="jbxx-title">基本信息</p>
            <table cellspacing="0" style="width: 100%; font-size: 15px">
              <tr>
                <td class="tabal-title-bg" style="min-width: 100px">
                  事项名称
                </td>
                <td class="tl">{{ matterObj.matter.name }}</td>
                <td class="tabal-title-bg" style="min-width: 100px">
                  办理部门
                </td>
                <td class="tl">{{ matterObj.matter.deptName }}</td>
              </tr>
              <tr>
                <td class="tabal-title-bg" style="min-width: 100px">
                  事项类型
                </td>
                <td class="tl">{{ matterObj.matter.itemName }}</td>
                <td class="tabal-title-bg" style="min-width: 100px">
                  服务类型
                </td>
                <td class="tl">{{ filterService(matterObj.matter.serviceTypeId) }}</td>
              </tr>
              <tr>
                <td class="tabal-title-bg" style="min-width: 100px">
                  法定办结时限
                </td>
                <td class="tl">{{ matterObj.matter.statutoryCompletion }}个工作日</td>
                <td class="tabal-title-bg" style="min-width: 100px">
                  承诺办结时限
                </td>
                <td class="tl">{{ matterObj.matter.promiseCompletion }}个工作日</td>
              </tr>
              <tr>
                <td class="tabal-title-bg" style="min-width: 100px">
                  办理时间
                </td>
                <td class="tl" colspan="3">{{ matterObj.handleTime }}</td>
              </tr>
              <tr>
                <td class="tabal-title-bg" style="min-width: 100px">
                  办理地点
                </td>
                <td class="tl" colspan="3">{{ matterObj.handleAddress }}</td>
              </tr>
              <tr>
                <td class="tabal-title-bg" style="min-width: 100px">
                  咨询电话
                </td>
                <td class="tl">
                  {{ filterNumber(matterObj.consultingPhone) }}
                </td>
                <td class="tabal-title-bg" style="min-width: 100px">
                  投诉电话
                </td>
                <td class="tl" style="min-width: 100px">
                  {{ filterNumber(matterObj.supervisePhone) }}
                </td>
              </tr>
            </table>
          </div>
          <div class="jbxx" v-if="matterObj.isQuestionaire">
            <p class="jbxx-title">情形选择</p>
            <guide :model="templateByMatterArr" @toGuide="toGuide" />
            <div class="flex-row" style="margin-top;: 10px;text-align:left;">
              <el-button type="primary" @click="goSwitch">确 定</el-button>
            </div>
          </div>
          <div class="sqcl" id="t2">
            <p class="sqcl-title">申请材料</p>
            <!--事项无情形选择时不展示，有情形时，点击不同情形按钮，切换不同情形对应申请材料-->
            <div
              v-if="
                matterObj.deptMatterMaterialList &&
                matterObj.deptMatterMaterialList.length > 0
              "
            >
              <div
                class="qxxz"
                v-if="
                  matterObj.deptMatterTemplates &&
                  matterObj.deptMatterTemplates.length > 0
                "
              >
                <p class="qxxz-title" style="">情形选择</p>
                <div class="qx-btns" style="margin-bottom: 10px">
                  <el-button
                    class="qx-btn"
                    :class="showqx == index ? 'on' : ''"
                    size="mini"
                    v-for="(item, index) in matterObj.deptMatterTemplates"
                    :key="index"
                    @click="SituationMaterials(item, index)"
                    >{{ item.conditionName }}</el-button
                  >
                  <!-- <el-button size="mini">通过...</el-button> -->
                </div>
              </div>
              <!-- 所有申请材料展示 -->
              <!-- v-if="!showSituationMaterials" -->
              <el-table
                border
                :data="matterObj.deptMatterMaterialList"
                style="width: 100%"
              >
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column label="材料名称">
                  <template slot-scope="scope">
                    <!-- <div v-if="scope.row.type == '委托材料'">
                      {{ scope.row.name
                      }}<span class="wtcl">{{
                    scope.row.originalType == 0
                      ? "原件"
                      : scope.row.originalType == 1
                      ? "复印件"
                      : "原件及复印件"
                  }}</span
                  ><span class="wtcl">{{ scope.row.copys }}份</span>
                    </div> -->
                    <div>
                      {{ scope.row.name
                      }}<span class="wtcl">{{
                    scope.row.originalType == 0
                      ? "原件"
                      : scope.row.originalType == 1
                      ? "复印件"
                      : "原件及复印件"
                  }}</span
                  ><span class="wtcl">{{ scope.row.copys }}份</span>
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="checkMain" label="材料要点">
                </el-table-column> -->
                <el-table-column
              prop="checkMain"
              label="示例样表"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-tag
                    type="success"
                    size="mini"
                    class="btn"
                    @click="exampleOpen(scope.$index)"
                    >材料样例</el-tag
                  >
                  <el-tag
                    style="margin-top: 10px"
                    size="mini"
                    class="btn"
                    @click="emptyDocumentOpen(scope.$index)"
                    >空白表单</el-tag
                  >
                </div>
              </template>
            </el-table-column>
              </el-table>

              <!-- 对应情形材料展示 -->
              <!-- <el-table
                v-else
                border
                :data="SituationMaterList"
                style="width: 100%"
              >
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column label="材料名称">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type == '委托材料'">
                      {{ scope.row.name }}
                      <span class="wtcl">{{ scope.row.type }}</span>
                    </div>
                    <div v-else>{{ scope.row.name }}</div>
                  </template>
                </el-table-column>
              </el-table> -->
            </div>
            <p v-if="
                matterObj.deptMatterMaterialList &&
                matterObj.deptMatterMaterialList.length == 0 || !matterObj.isQuestionaire
              " style="text-align: left">无申请材料</p>
            <!-- 如果有情形展示该情形是否可代办 无情形展示事项是否可代办-->
            <!-- 无情形 -->
            <!-- <p
              class="sfdb"
              v-if="
                matterObj.deptMatterTemplates &&
                matterObj.deptMatterTemplates.length == 0 &&
                matterObj.agencyStatus == '0' &&
                matterObj.agencyCondition != null
              "
            >
              代办要求：&nbsp;&nbsp;{{ matterObj.agencyCondition }}
            </p>
            <p
              class="sfdb"
              v-if="
                matterObj.deptMatterTemplates &&
                matterObj.deptMatterTemplates.length == 0 &&
                matterObj.agencyStatus == '0' &&
                matterObj.agencyCondition == null
              "
            >
              该事项可代办，无代办要求
            </p>
            <p
              class="sfdb"
              v-if="
                matterObj.deptMatterTemplates &&
                matterObj.deptMatterTemplates.length == 0 &&
                matterObj.agencyStatus == '1'
              "
            >
              该事项不可代办
            </p> -->
            <!-- 有情形 -->
            <!-- <p
              class="sfdb"
              v-if="
                matterObj.deptMatterTemplates &&
                matterObj.deptMatterTemplates.length > 0 &&
                matterObj.deptMatterTemplates[index].agencyStatus == '0' &&
                DescriptionOfTheSituation
              "
            >
              该情形可代办，代办要求：&nbsp;&nbsp;{{
                DescriptionOfTheSituation
              }}
            </p>
            <p
              class="sfdb"
              v-if="
                matterObj.deptMatterTemplates &&
                matterObj.deptMatterTemplates.length > 0 &&
                matterObj.deptMatterTemplates[index].agencyStatus == '0' &&
                (DescriptionOfTheSituation == '' ||
                  DescriptionOfTheSituation == null)
              "
            >
              该情形可代办，无代办要求
            </p>
            <p
              class="sfdb"
              v-if="
                matterObj.deptMatterTemplates &&
                matterObj.deptMatterTemplates.length > 0 &&
                matterObj.deptMatterTemplates[index].agencyStatus == '1'
              "
            >
              该情形不可代办
            </p> -->
          </div>
          <div class="fdyj" id="t3">
            <p class="fdyj-title">法定依据</p>
            <p class="tl" style="font-size: 15px; margin-bottom: 5px">
              {{ matterObj.matter.statutoryBasis }}
            </p>
          </div>
          <div class="sqtj" id="t4">
            <p class="sqtj-title">申请条件</p>
            <p class="tl" style="font-size: 15px">
              {{ matterObj.matter.applicationConditions }}
            </p>
          </div>
          <div class="sfbz" id="t5">
            <p class="sfbz-title">收费标准</p>
            <p class="tl">{{ matterObj.matter.chargingBasis }}</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="材料样例"
      :visible.sync="example"
      width="600px"
      append-to-body
    >
      <div class="imglist" v-if="deptMatterTemplates[indexApplicationMaterial]">
        <div
          v-for="(i, idx) in matterObj.deptMatterMaterialList[
            indexApplicationMaterial
          ].styles"
          :key="idx"
        >
          <div
            class="icon flex-row"
            style="cursor: pointer"
            v-for="(item, index) in i.deptFileExampleList"
            :key="index"
            @click="handleGenTable(item)"
          >
            <span>{{ item.name }}</span>
            <div class="flex-row" style="width: 65px">
              <i class="el-icon-download"></i>
              <span>下载</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="example = false" size="mini"
          >确 定</el-button
        >
        <el-button @click="example = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="空白文档"
      :visible.sync="emptyDocument"
      width="600px"
      append-to-body
    >
      <div class="imglist" v-if="deptMatterTemplates[indexApplicationMaterial]">
        <div
          v-for="(i, idx) in matterObj.deptMatterMaterialList[
            indexApplicationMaterial
          ].styles"
          :key="idx"
        >
          <div
            class="icon flex-row"
            style="cursor: pointer"
            v-for="(item, index) in i.deptFileTableList"
            :key="index"
            @click="handleGenTable(item)"
          >
            <span>{{ item.name }}</span>
            <div class="flex-row">
              <i class="el-icon-download"></i>
              <span>下载</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="emptyDocument = false" size="mini"
          >确 定</el-button
        >
        <el-button @click="emptyDocument = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { matterInfo, unauthorized } from "@/api/map/index";
import { download } from "@/api/user/index";
import guide from "@/components/rollUp/guide";
export default {
  name: "ServiceGuide",
  components: { guide },
  data() {
    return {
      navgatorIndex: 1,
      loading: false,
      // matterId: this.$route.query.matterId || null, //事项ID
      // matterName: this.$route.query.name || null, //事项名称
      deptMatterId: this.$route.params.deptMatterId || null, //事项ID
      matterName: this.$route.params.name || null, //事项名称
      id: "", //情形项ID
      isfixTab: false,
      matterObj: {matter: {}}, //事项详情对象
      AllMaterials: [], //事项所有材料
      showSituationMaterials: false, //展示情形材料
      SituationMaterList: [], //情形材料
      showqx: false,
      DescriptionOfTheSituation: "", //情形代办说明
      index: 0, //当前情形项
      deptMatterTemplates: [], //所有情形项
      templateByMatterArr: [],
      rollUp: [],
      example: false,
      emptyDocument: false,
      indexApplicationMaterial: 0,
    };
  },
  mounted() {
    // console.log(this.$route.query);
    this.getDetail();
    window.addEventListener("scroll", this.handleTabFix, true);
  },
  //离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleTabFix, true);
    next();
  },
  methods: {
    // 事项详情
    getDetail() {
      // 事项详情  post  参数 matterId  事项id
      let params = {
        deptMatterId: this.deptMatterId,
      };
      this.loading = true;
      let obj={method:'/zwmap/matterInfo',body:JSON.stringify(params)}
      // matterInfo(params).then((res) => {
      unauthorized(obj).then((res) => {
        // console.log(res, '事项详情')
        this.loading = false;
        if (res.data.code == 200) {
          this.matterObj = res.data.data;
          this.matterObj.matter = this.matterObj.matter || {};
          // // 该事项有情形
          // if (this.matterObj.deptMatterTemplates.length > 0) {
          //   this.deptMatterTemplates = this.matterObj.deptMatterTemplates;
          //   this.id = this.matterObj.deptMatterTemplates[0].id;
          //   // console.log(this.id,'id?')
          //   this.showSituationMaterials = true;
          //   // 获取第一个情形下的材料列表--有情形的情况下默认展示第一个情形的材料
          //   this.SituationMaterList = this.matterObj.deptMatterTemplates[0].deptScienceList
          // }
          if (!this.matterObj.isQuestionaire) {
            this.deptMatterTemplates = this.matterObj.deptMatterMaterialList;
          } else {
            let obj = {
              deptMatterId: this.deptMatterId,
              parentId: 0,
            };
            unauthorized({
              method: "/zwmap/getOneLevelQuestionnaire",
              body: JSON.stringify(obj),
            }).then((r) => {
              this.templateByMatterArr = r.data.data;
              // this.showSituationMaterials = true;
            });
          }
        } else {
          this.$message.error(res.data.msg);
          this.loading = false;
        }
      });
    },
    // 情形引导
    toGuide(val) {
      this.rollUp = val;
    },
    // 情形引导提交
    goSwitch() {
      let params = {
        deptMatterId: this.deptMatterId,
        agencySingleDeptQuestionaireSelectSaveList: this.rollUp,
      };
      if (this.rollUp.length != 0) {
        unauthorized({
          method: "/zwmap/getQuestionnaireMaterial",
          body: JSON.stringify(params),
        }).then((res) => {
          this.$message({
            message: `${res.data.msg}`,
            type: "success",
          });
          this.matterObj.deptMatterMaterialList = res.data.data;
          this.deptMatterTemplates = this.matterObj.deptMatterMaterialList;
          console.log('deptMatterMaterialList', this.matterObj.deptMatterMaterialList);
        });
      } else {
        this.$message({
          message: "请选择情形后确认",
          type: "warning",
        });
      }
    },
     // 材料样例
     exampleOpen(index) {
      this.indexApplicationMaterial = index;
      if (this.matterObj.deptMatterMaterialList[index].styles.length != 0) {
        if (
          this.matterObj.deptMatterMaterialList[index].styles[0]
            .deptFileExampleList.length != 0
        ) {
          this.example = true;
        } else {
          this.$message({
            message: "无材料样例",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "无材料样例",
          type: "warning",
        });
      }
    },
    // 空白表单
    emptyDocumentOpen(index) {
      this.indexApplicationMaterial = index;
      if (this.matterObj.deptMatterMaterialList[index].styles.length != 0) {
        if (
          this.matterObj.deptMatterMaterialList[index].styles[0]
            .deptFileExampleList.length != 0
        ) {
          this.emptyDocument = true;
        } else {
          this.$message({
            message: "无空白表单",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "无空白表单",
          type: "warning",
        });
      }
    },
    // 封装blob对象
    dataURLToBlob(base64Str, mimeTypeStr) {
      let bstr = window.atob(base64Str); // 解码 base-64 编码的字符串，base-64 编码使用方法是 btoa()
      let length = bstr.length;
      let u8arr = new Uint8Array(length); // 创建初始化为0的，包含length个元素的无符号整型数组
      while (length--) {
        u8arr[length] = bstr.charCodeAt(length); // 返回在指定的位置的字符的 Unicode 编码
      }
      return new Blob([u8arr], { type: mimeTypeStr }); // 返回一个blob对象
     },
     // 预览下载
     handleGenTable(file) {
      download({
        filePath: file.filePath,
        fileName: file.name,
      }).then((res) => {
        // let url = window.URL.createObjectURL(new Blob([res.data.base64]));
        console.log('download', res.data.data);
        if (res.data.code == 200) {
          let myBlob = this.dataURLToBlob(res.data.data.base64, res.data.data.mimeType);
          let url = window.URL.createObjectURL(myBlob);
          // let url = 'data:'+res.data.data.mimeType+';base64,' + res.data.data.base64;
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          let filename = file.name;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link) // 下载完成移除元素
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        }

      });
    },
    // 情形材料切换
    SituationMaterials(item, index) {
      this.id = item.id;
      this.SituationMaterList = [];
      let list = item.deptScienceList;
      // console.log(list, '情形项材料')
      this.showSituationMaterials = true;
      this.showqx = index;
      // 对应情形下的材料名称和所有材料中的名称对比，完善情形下材料的所有信息--材料要点、材料示例等
      this.SituationMaterList = list; 
      // 代办要求
      this.DescriptionOfTheSituation =
        this.matterObj.deptMatterTemplates[index].agencyCondition;
      this.index = index;
    },
    // 地图指引--跳转到地图页面
    toMap(matterObj) {
      // this.$router.push({
      //   name: "index",
      //   query: { name }
      // })
      let obj = {
        deptMatterId: matterObj.deptMatterId,
        name: matterObj.name,
        addressName: matterObj.hanyuanMapList[0].name,
      };
      sessionStorage.setItem("matterDetails", JSON.stringify(obj));
      this.$router.push({
        name: "index",
        params: obj,
      });
    },
    // 鼠标滚动定位菜单
    // handleLeft(val) {
    //   this.navgatorIndex = val;
    // },
    handleLeft(id, val) {
      this.navgatorIndex = null;
      // console.log(id,val,document.getElementById(`${id}`),'@@@@')
      document.getElementById(`${id}`).scrollIntoView();
      this.navgatorIndex = val;
    },
    handleTabFix() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = 345; //345页面头部加标题的高度，当页面滚动超过标题则固定左侧菜单；
      scrollTop > offsetTop ? (this.isfixTab = true) : (this.isfixTab = false);
      var jbxxH = document.getElementById("t1").clientHeight + offsetTop;
      var sqclH = document.getElementById("t2").clientHeight + jbxxH;
      var fdyjH = document.getElementById("t3").clientHeight + jbxxH + sqclH;
      var sqtjH =
        document.getElementById("t4").clientHeight + jbxxH + sqclH + fdyjH;
      var dom = document.getElementById("cont-right");

      var scrollHeight = dom.scrollHeight;
      // console.log(scrollTop, jbxxH, sqclH, fdyjH, sqtjH, '????')
      // console.log(scrollTop, scrollHeight, '????')
      // var sfbzH = document.getElementById('t5').clientHeight+offsetTop+jbxxH+sqclH+fdyjH+sqtjH;
      if (scrollTop >= scrollHeight) {
        this.navgatorIndex = 5;
        // console.log('滑到底了')
      } else if (scrollTop >= jbxxH / 2 && scrollTop < sqclH / 2) {
        this.navgatorIndex = 2;
      } else if (scrollTop >= sqclH / 2 && scrollTop < fdyjH / 2) {
        this.navgatorIndex = 3;
      } else if (scrollTop >= fdyjH / 2 && scrollTop < sqtjH / 2) {
        this.navgatorIndex = 4;
      } else if (scrollTop >= sqtjH / 2) {
        this.navgatorIndex = 5;
      } else {
        this.navgatorIndex = 1;
      }
    },
    filterNumber(val) {
      if (val) {
        let index = val.indexOf("：");
        return val.slice(index + 1);
      }
    },
    filterService(str) {
      let st = "";
      if (str) {
        let arr = str.split(",");
        if (str.length > 1) {
          arr.forEach((el) => {
            if (el == "1") {
              st += "个人服务 ";
            } else if (el == "2") {
              st += "法人服务 ";
            }
          });
        } else {
          if (str == "1") {
            st = "个人服务";
          } else if (str == "2") {
            st = "法人服务";
          }
        }
        return st;
      }
    },
  },
  created() {
    if (sessionStorage.getItem("matterDetails")) {
      this.deptMatterId = JSON.parse(
        sessionStorage.getItem("matterDetails")
      ).deptMatterId;
      this.matterName = JSON.parse(
        sessionStorage.getItem("matterDetails")
      ).name;
    }
    this.$emit("public_header", true);
    this.$emit("public_footer", true);
  },
};
</script>
<style scoped>
.banner {
  /*background: url('./../../assets/img/bg.png');*/
  height: 155px;
  background-size: 100% auto;
  position: absolute;
  top: 125px;
  width: 100%;
}

.fixedNavbar {
  position: fixed;
  top: 0;
}

.on {
  background: #0492fa !important;
  color: #fff !important;
}

.wtcl {
  background-color: rgb(231, 231, 231);
  padding: 3px 5px;
  margin-left: 10px;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  font-size: 12px;
}

.top-title {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  position: absolute;
  top: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
}

.Map_guidance {
  position: absolute;
  right: 125px;
  top: 110px;
}
.online_application {
  position: absolute;
  right: 10px;
  top: 110px;
}
.Map_guidance:hover {
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
}
.online_application:hover {
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
}

.cont {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.cont-left {
  border-right: 1px solid #dadada;
  height: 200px;
  float: left;
}

.cont-left li {
  padding: 10px;
}

.active {
  border-right: 2px solid #3ea6ed;
}

#cont-right {
  width: 90%;
  float: right;
  margin-bottom: 60px;
}

.jbxx table td {
  padding: 10px;
  border: 1px solid #e8e9ec;
}

.jbxx .jbxx-title,
.sqcl .sqcl-title,
.fdyj .fdyj-title,
.fdyj .fdyj-title,
.sqtj .sqtj-title,
.sfbz .sfbz-title {
  padding: 10px;
  border-bottom: 1px solid #dadada;
  margin-bottom: 10px;
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  padding-left: 0;
}

.sqcl .qxxz-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
  text-align: left;
}

.sqcl .sfdb {
  margin: 10px 0;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
  text-align: left;
}

.tl {
  text-align: left;
}

.qx-btns {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.qx-btn {
  margin-right: 10px;
  margin-bottom: 10px;
  margin-left: 0 !important;
}

.tabal-title-bg {
  background-color: #f5f6f8;
}
.icon {
  cursor: pointer;
  margin-top: 10px;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
.btn{
  cursor: pointer;
}
.flex-row {
  display: flex;
  align-items: center;
}
.el-icon-download:before {
    vertical-align: sub;
}
</style>